<template>
	<div>
		<login-after-head></login-after-head>
		<head-nav-bar></head-nav-bar>

		<div class="container" v-loading="loading">
			<div class="selection-placeholder" v-if="!pageReady"></div>
			<div class="mbx-row fc" v-show="pageReady">
				<div class="container-left">
					<router-link to="index">首页</router-link>
					<template v-if="cateNav.cate1Name">
						<i class="icon-arrow-right4 magr12l8"></i>
						<router-link :to="cate1Link">{{ cateNav.cate1Name }}</router-link>
					</template>
					<template v-if="cateNav.cate2Name">
						<span><i class="icon-arrow-right4 magr12l8"></i></span>
						<router-link :to="cate2Link">{{ cateNav.cate2Name }}</router-link>
					</template>
					<span><i class="icon-arrow-right4 magr12l8"></i></span>
					<span>{{ seriesCrumbName }}</span>
					<span><i class="icon-arrow-right4 magr12l8"></i></span>
				</div>
			</div>

			<div class="selection-main flex" v-show="pageReady">
				<div class="selection-left">
					<div class="product-img-area">
						<img v-if="currentImage" :src="currentImage" class="main-img" />
						<img v-else src="../assets/noll.png" style="width:100%" />
						<div class="img-thumbs" v-if="sliderImages.length > 1">
							<img v-for="(img, idx) in sliderImages" :key="idx" :src="img"
								:class="{active: currentImage === img}" @click="currentImage = img" />
						</div>
					</div>
					<div class="info-block">
						<div class="info-row price-row">
							<span class="info-label">售价：</span>
							<span class="price-symbol" v-if="displayPrice">￥</span>
							<span class="price-num" v-if="displayPrice">{{ formattedDisplayPrice }}</span>
							<span class="price-num" v-else>面议</span>
						</div>
						<div class="info-row" v-if="description">{{ description }}</div>
						<div class="info-row material-row" v-if="currentItemNum">物料编码：{{ currentItemNum }}</div>
						<div class="info-row material-row empty" v-else-if="complete && !matchedItems.length">未匹配到现成物料</div>
					</div>
				</div>

				<div class="selection-right">
					<div class="attr-section" v-for="(item, idx) in attributes" :key="idx">
						<div class="attr-title">
							<i class="attr-dot"></i>
							<span class="attr-name">{{ item.attrName }}<span class="req" v-if="item.required">*</span></span>
							<span class="locked-tip" v-if="item.status === 'LOCKED'">{{ item.lockedReason || '暂不可选' }}</span>
						</div>
						<div class="attr-options">
							<span class="attr-opt sel-opt" v-if="!item.required && item.status !== 'LOCKED'"
								:class="{on: isNoneSelected(item)}" @click="chooseValue(item, noneValue)">不选</span>
							<span class="attr-opt sel-opt" v-for="(opt, oi) in visibleOptions(item)" :key="oi"
								:class="{on: isOptionSelected(item, opt)}" @click="chooseValue(item, opt)">
								{{ opt.attrValueName || opt.attrValue }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<i-footer></i-footer>
		<fixed-right></fixed-right>
	</div>
</template>

<script>
import { getAttrTree, resolveDescGen, DESC_GEN_NONE } from '@/api/descGen'
import { queryProducts, queryCategoryList, getQueryCateByProductId } from '@/api/home'
import { getNormalProductDetail } from '@/api/indexpage'

export default {
	data() {
		return {
			noneValue: DESC_GEN_NONE,
			loading: true,
			pageReady: false,
			categoryId: '',
			queryKeyword: '',
			product: {},
			selected: {},
			attributes: [],
			description: '',
			complete: false,
			price: null,
			priceDisplayFlag: null,
			priceDetails: [],
			matchedItems: [],
			currentItemNum: '',
			resolveSeq: 0,
			optionHideMap: {},
			sliderImages: [],
			currentImage: '',
			cateNav: {
				cate1Id: '',
				cate1Name: '',
				midId: '',
				cate2Id: '',
				cate2Name: '',
				seriesName: ''
			}
		}
	},
	computed: {
		seriesCrumbName() {
			return this.cateNav.seriesName || this.seriesTitle
		},
		cate1Link() {
			return {
				path: '/list',
				query: {
					cate1Id: this.cateNav.cate1Id,
					cate2Id: this.cateNav.midId || this.cateNav.cate1Id
				}
			}
		},
		cate2Link() {
			return {
				path: '/list',
				query: {
					cate2Id: this.cateNav.midId || this.cateNav.cate1Id,
					cate3Id: this.cateNav.cate2Id
				}
			}
		},
		seriesTitle() {
			if (this.product && this.product.storeInfo && this.product.storeInfo.storeName) {
				return this.product.storeInfo.storeName
			}
			return this.queryKeyword || '产品选型'
		},
		noBodyPrice() {
			if (this.priceDisplayFlag === 0) {
				return true
			}
			if (this.priceDisplayFlag === 1) {
				return false
			}
			const details = this.priceDetails || []
			return details.length > 0 &&
				!details.some((d) => d.partType == null || d.partType === '本体')
		},
		displayPrice() {
			if (this.noBodyPrice) {
				return null
			}
			if (this.matchedItemPrice) {
				return this.matchedItemPrice
			}
			return this.price
		},
		formattedDisplayPrice() {
			if (this.currentItemNum) {
				return this.displayPrice
			}
			return this.formatPrice(this.displayPrice)
		},
		matchedItemPrice() {
			const item = (this.matchedItems || []).find((x) => x.itemNum === this.currentItemNum)
			return item && item.price ? item.price : null
		},
	},
	mounted() {
		this.categoryId = this.$route.query.categoryId || this.$route.query.productId || ''
		this.queryKeyword = this.$route.query.keyword || ''
		if (!this.categoryId) {
			this.loading = false
			this.$message.warning('缺少系列参数 categoryId')
			return
		}
		this.initPage()
	},
	methods: {
		initPage() {
			if (this.queryKeyword) {
				document.title = '天正智选 - ' + this.queryKeyword
			}
			this.loading = true
			this.pageReady = false
			Promise.all([
				this.fetchProductDetail(),
				this.loadSeriesData(),
				this.loadCateBreadcrumb()
			]).then((results) => {
				if (results[1] === false) return
				this.pageReady = true
			}).finally(() => {
				this.loading = false
			})
		},
		parseCategoryCache(raw) {
			if (!raw) return null
			try {
				const parsed = JSON.parse(raw)
				if (Array.isArray(parsed)) return parsed
				if (parsed && Array.isArray(parsed.categorys)) return parsed.categorys
			} catch (e) { /* ignore */ }
			return null
		},
		loadCategoryTree() {
			const cached = this.parseCategoryCache(sessionStorage.getItem('categorys'))
			if (cached && cached.length) {
				return Promise.resolve(cached)
			}
			return queryCategoryList().then((res) => {
				const list = (res && res.categorys) || []
				sessionStorage.setItem('categorys', JSON.stringify(list))
				return list
			}).catch(() => [])
		},
		isCateNodeMatchId(item, cateId) {
			if (!item || cateId == null || cateId === '') return false
			const nid = Number(cateId)
			const sid = String(cateId)
			if (Number(item.id) === nid) return true
			if (item.categoryId != null && Number(item.categoryId) === nid) return true
			if (item.dmsTgCategoryId != null && Number(item.dmsTgCategoryId) === nid) return true
			if (item.dmsCat) {
				const cats = String(item.dmsCat).split(',').map((s) => s.trim())
				if (cats.indexOf(sid) > -1) return true
			}
			return false
		},
		findSeriesPath(tree, seriesId) {
			if (seriesId == null || !tree || !tree.length) return null
			for (let i = 0; i < tree.length; i++) {
				const l1 = tree[i]
				const children1 = l1.children || []
				for (let j = 0; j < children1.length; j++) {
					const l2 = children1[j]
					const children2 = l2.children || []
					if (this.isCateNodeMatchId(l2, seriesId)) {
						return { l1, l2, l3: null, series: l2 }
					}
					for (let k = 0; k < children2.length; k++) {
						const l3 = children2[k]
						const children3 = l3.children || []
						if (this.isCateNodeMatchId(l3, seriesId)) {
							return { l1, l2, l3, series: l3 }
						}
						for (let m = 0; m < children3.length; m++) {
							if (this.isCateNodeMatchId(children3[m], seriesId)) {
								return { l1, l2, l3, series: children3[m] }
							}
						}
					}
				}
			}
			return null
		},
		applyCatePath(path) {
			if (!path) return
			const seriesIsL2 = path.series === path.l2
			const parent = seriesIsL2 ? null : (path.l3 && path.series !== path.l3 ? path.l3 : path.l2)
			this.cateNav = {
				cate1Id: path.l1 && path.l1.id,
				cate1Name: path.l1 && path.l1.cateName,
				midId: path.l2 && path.l2.id,
				cate2Id: parent && parent.id,
				cate2Name: parent && parent.cateName,
				seriesName: (path.series && path.series.cateName) || ''
			}
		},
		loadCateBreadcrumb() {
			if (!this.categoryId) return Promise.resolve()
			const applyByIds = (tree, ids) => {
				const seriesId = (ids && (ids.categoryFourId || ids.categoryThreeId)) || this.categoryId
				let path = this.findSeriesPath(tree, seriesId)
				if (!path) path = this.findSeriesPath(tree, this.categoryId)
				this.applyCatePath(path)
			}
			return this.loadCategoryTree().then((tree) => {
				return getQueryCateByProductId({ productId: this.categoryId }).then((raw) => {
					const cate = raw && (raw.categoryFourId != null || raw.categoryOneId != null)
						? raw
						: ((raw && raw.data) || {})
					applyByIds(tree, cate)
				}).catch(() => {
					applyByIds(tree, {})
				})
			})
		},
		goToSeriesList() {
			this.fallbackToList()
		},
		fallbackToList() {
			const query = {}
			if (this.categoryId) {
				query.productId = this.categoryId
			}
			this.$router.replace({ path: '/list', query })
		},
		fetchProductDetail() {
			if (!this.categoryId) return Promise.resolve()
			return getNormalProductDetail(this.categoryId).then((res) => {
				const data = (res && res.data) ? res.data : (res || {})
				if (data && (data.storeInfo || data.storeName || data.id)) {
					this.product = data
					this.buildSliderImages()
					return
				}
				return this.fetchProductByCategory()
			}).catch(() => {
				return this.fetchProductByCategory()
			})
		},
		fetchProductByCategory() {
			return queryProducts({ categoryId: this.categoryId }).then((res) => {
				if (!res || !res.id) {
					this.product = {}
					return
				}
				return getNormalProductDetail(res.id).then((detail) => {
					this.product = (detail && detail.data) ? detail.data : {}
					this.buildSliderImages()
				})
			}).catch(() => {
				this.product = {}
			})
		},
		buildSliderImages() {
			this.sliderImages = []
			const store = this.product.storeInfo || {}
			if (store.sliderImageArr && store.sliderImageArr.length) {
				this.sliderImages = store.sliderImageArr
			} else if (store.sliderImage) {
				this.sliderImages = store.sliderImage.split(',').filter(Boolean)
			}
			this.currentImage = this.sliderImages[0] || ''
		},
		hasAttrTreeData(res) {
			if (!res || res.success === false) return false
			if (res.status != null && Number(res.status) !== 200) return false
			const list = res.data
			return Array.isArray(list) && list.length > 0
		},
		loadSeriesData() {
			return getAttrTree(this.categoryId).then((res) => {
				if (!this.hasAttrTreeData(res)) {
					this.fallbackToList()
					return false
				}
				this.attributes = this.mapAttrTree(res.data || [])
				if (!this.attributes.length) {
					this.fallbackToList()
					return false
				}
				return this.doResolve().then(() => true)
			}).catch(() => {
				this.fallbackToList()
				return false
			})
		},
		mapAttrTree(list) {
			const hideMap = {}
			const mapped = (list || []).map((item) => {
				const values = (item.values || []).filter((val) => val.status !== 0)
				return {
					attrId: item.attrId,
					attrName: item.attrName,
					status: 'FREE',
					lockedReason: '',
					selectedValue: null,
					required: false,
					options: values.map((val) => {
						const valKey = val.serAttrValueId != null && val.serAttrValueId !== ''
							? String(val.serAttrValueId)
							: String(val.attrValue != null ? val.attrValue : '')
						if (valKey) {
							hideMap[String(item.attrId) + ':' + valKey] = val.hideDescGenFlag
						}
						return {
							serAttrValueId: val.serAttrValueId,
							attrValue: val.attrValue,
							attrValueName: val.attrValueName || val.attrValue,
							selectable: true,
							hideDescGenFlag: val.hideDescGenFlag
						}
					})
				}
			})
			this.optionHideMap = hideMap
			return mapped
		},
		formatPrice(value) {
			const n = Number(value)
			if (!isFinite(n) || n === 0) return ''
			if (n > 500) return String(Math.round(n))
			if (n < 50) return (Math.round(n * 100) / 100).toFixed(2)
			return (Math.round(n * 10) / 10).toFixed(1)
		},
		isAttrLocked(item) {
			return String((item && item.status) || '').toUpperCase() === 'LOCKED'
		},
		isOptionHidden(item, opt) {
			if (!opt || typeof opt !== 'object') return false
			let flag = opt.hideDescGenFlag
			if (flag == null && item) {
				flag = this.optionHideMap[String(item.attrId) + ':' + this.optionValue(opt)]
			}
			return flag === 1 || flag === '1' || flag === true
		},
		isOptionSelectable(item, opt) {
			if (this.isAttrLocked(item)) return false
			if (this.isOptionHidden(item, opt)) return false
			if (!opt || typeof opt !== 'object') return true
			return opt.selectable !== false && opt.selectable !== 'false' && opt.selectable !== 0
		},
		visibleOptions(item) {
			return (item && item.options || []).filter((opt) => this.isOptionSelectable(item, opt))
		},
		optionValue(opt) {
			if (opt == null) return ''
			if (typeof opt !== 'object') return String(opt)
			if (opt.serAttrValueId != null && opt.serAttrValueId !== '') return String(opt.serAttrValueId)
			return String(opt.attrValue != null ? opt.attrValue : '')
		},
		isNoneSelected(item) {
			return this.currentAttrValue(item) === DESC_GEN_NONE
		},
		isOptionSelected(item, opt) {
			return this.currentAttrValue(item) === this.optionValue(opt)
		},
		currentAttrValue(item) {
			if (!item) return ''
			const fromMap = this.selected[String(item.attrId)]
			if (fromMap != null && fromMap !== '') return String(fromMap)
			if (item.selectedValue != null && item.selectedValue !== '') return String(item.selectedValue)
			return ''
		},
		chooseValue(item, opt) {
			if (!item) return
			if (this.isAttrLocked(item)) {
				this.$message.warning(item.lockedReason || '请先选择前置属性')
				return
			}
			if (opt !== DESC_GEN_NONE && !this.isOptionSelectable(item, opt)) {
				this.$message.warning('当前选项不可选')
				return
			}
			if (!this.categoryId) {
				this.$message.warning('缺少系列参数 categoryId')
				return
			}
			const value = opt === DESC_GEN_NONE ? DESC_GEN_NONE : this.optionValue(opt)
			if (!value) return
			if (this.currentAttrValue(item) === value) return
			const attrId = String(item.attrId)
			this.$set(this.selected, attrId, value)
			this.$set(item, 'selectedValue', value)
			this.doResolve()
		},
		resolveErrorMessage(err) {
			if (!err) return '解析失败'
			if (err.msg) return err.msg
			const body = err.response && err.response.data
			if (body && (body.msg || body.message)) return body.msg || body.message
			if (err.message && err.message.indexOf('Request failed') === -1) return err.message
			return '解析失败'
		},
		doResolve() {
			const categoryId = this.categoryId
			this.resolveSeq += 1
			const seq = this.resolveSeq
			const loop = (selected, depth) => {
				return resolveDescGen(categoryId, selected).then((res) => {
					if (seq !== this.resolveSeq) return
					const data = res.data || {}
					const attrs = data.attributes || []
					const nextSelected = Object.assign({}, selected)
					this.mergeResolveSelected(attrs, nextSelected)
					if (depth < 20 && this.pickFirstOptions(attrs, nextSelected)) {
						return loop(nextSelected, depth + 1)
					}
					this.selected = nextSelected
					this.applyResolve(data)
				})
			}
			return loop(Object.assign({}, this.selected), 0).catch((err) => {
				if (seq !== this.resolveSeq) return
				this.$message.error(this.resolveErrorMessage(err))
			})
		},
		mergeResolveSelected(attrs, selectedMap) {
			;(attrs || []).forEach((attr) => {
				const key = String(attr.attrId)
				if (selectedMap[key] === DESC_GEN_NONE) return
				if (attr.selectedValue != null && attr.selectedValue !== '') {
					selectedMap[key] = String(attr.selectedValue)
					return
				}
				delete selectedMap[key]
			})
		},
		pickFirstOptions(attrs, selectedMap) {
			let changed = false
			;(attrs || []).forEach((attr) => {
				const key = String(attr.attrId)
				if (this.isAttrLocked(attr)) {
					if (selectedMap[key]) {
						delete selectedMap[key]
						changed = true
					}
					return
				}
				if (selectedMap[key] === DESC_GEN_NONE && !attr.required) return
				const selectableOptions = (attr.options || []).filter((opt) => this.isOptionSelectable(attr, opt))
				const current = selectedMap[key]
				const valid = current && selectableOptions.some((opt) => this.optionValue(opt) === String(current))
				if (valid) return
				if (selectableOptions.length) {
					const first = this.optionValue(selectableOptions[0])
					if (first) {
						selectedMap[key] = first
						changed = true
					}
				} else if (selectedMap[key]) {
					delete selectedMap[key]
					changed = true
				}
			})
			return changed
		},
		applyResolve(data) {
			const attrs = data.attributes || []
			const nextSelected = Object.assign({}, this.selected)
			const hideMap = {}
			;(this.attributes || []).forEach((attr) => {
				const attrKey = String(attr.attrId)
				;(attr.options || []).forEach((opt) => {
					const valKey = this.optionValue(opt)
					if (valKey) hideMap[attrKey + ':' + valKey] = opt.hideDescGenFlag
				})
			})
			this.attributes = attrs.map((attr) => {
				const key = String(attr.attrId)
				const options = (attr.options || []).map((opt) => {
					const valKey = this.optionValue(opt)
					const hideDescGenFlag = opt.hideDescGenFlag != null ? opt.hideDescGenFlag : hideMap[key + ':' + valKey]
					return Object.assign({}, opt, { hideDescGenFlag })
				})
				return Object.assign({}, attr, { options, selectedValue: nextSelected[key] != null ? nextSelected[key] : null })
			})
			this.description = data.description || ''
			this.complete = !!data.complete
			this.price = data.price == null || data.price === 0 ? null : data.price
			this.priceDisplayFlag = data.priceDisplayFlag != null ? Number(data.priceDisplayFlag) : null
			this.priceDetails = data.priceDetails || []
			this.matchedItems = data.matchedItems || []
			const firstMatched = this.matchedItems[0]
			this.currentItemNum = firstMatched ? firstMatched.itemNum : ''
			if (!this.noBodyPrice && firstMatched && firstMatched.price) {
				this.price = firstMatched.price
			}
		}
	}
}
</script>

<style scoped lang="less">
.selection-placeholder {
	min-height: 420px;
}

.breadcrumb-link {
	cursor: pointer;
	color: #666;
	&:hover {
		color: #57ACA7;
	}
}

.selection-main {
	margin-top: 12px;
	align-items: flex-start;
	gap: 20px;

	.selection-left {
		width: 280px;
		flex-shrink: 0;
		.product-img-area {
			border: 1px solid #eee;
			padding: 8px;
			.main-img {
				width: 100%;
				height: 220px;
				object-fit: contain;
			}
			.img-thumbs {
				display: flex;
				gap: 6px;
				margin-top: 6px;
				flex-wrap: wrap;
				img {
					width: 44px;
					height: 44px;
					object-fit: contain;
					border: 1px solid #ddd;
					cursor: pointer;
					&.active {
						border-color: #57ACA7;
					}
				}
			}
		}
		.info-block {
			background: #f9f9f9;
			padding: 10px 12px;
			margin-top: 10px;
			border-radius: 4px;
			.info-row {
				margin-bottom: 6px;
				color: #666;
				font-size: 13px;
				line-height: 1.4;
				word-break: break-all;
				&:last-child {
					margin-bottom: 0;
				}
			}
			.price-row {
				.price-symbol {
					color: #e54d42;
					font-size: 13px;
				}
				.price-num {
					color: #e54d42;
					font-size: 20px;
					font-weight: bold;
				}
			}
			.material-row {
				color: #333;
				&.empty {
					color: #999;
				}
			}
		}
	}

	.selection-right {
		flex: 1;
		min-width: 0;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		padding: 14px 16px 8px;
		background: #fff;

		.attr-section {
			display: flex;
			align-items: flex-start;
			margin-bottom: 10px;
			padding-bottom: 8px;
			border-bottom: 1px dashed #eee;
			&:last-child {
				margin-bottom: 0;
				padding-bottom: 0;
				border-bottom: 0;
			}
			.attr-title {
				width: 158px;
				flex-shrink: 0;
				display: flex;
				align-items: flex-start;
				padding-top: 4px;
				font-size: 13px;
				color: #333;
				font-weight: 600;
				line-height: 22px;
				white-space: nowrap;
				.attr-dot {
					width: 0;
					height: 0;
					margin: 7px 8px 0 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 6px solid #57ACA7;
					flex-shrink: 0;
				}
				.attr-name {
					white-space: nowrap;
				}
				.req {
					color: #e54d42;
					margin-left: 2px;
				}
				.locked-tip {
					display: block;
					margin-top: 0;
					font-size: 11px;
					color: #999;
					font-weight: normal;
					white-space: normal;
				}
			}
			.attr-options {
				flex: 1;
				min-width: 0;
				display: flex;
				flex-wrap: wrap;
				gap: 6px;
				.attr-opt {
					display: inline-block;
					padding: 3px 10px;
					border: 1px solid #ddd;
					border-radius: 2px;
					cursor: pointer;
					font-size: 12px;
					line-height: 18px;
					color: #666;
					user-select: none;
					&:hover {
						border-color: #57ACA7;
						color: #57ACA7;
					}
					&.on {
						border-color: #57ACA7;
						background: #eaf6f5;
						color: #57ACA7;
						font-weight: 600;
					}
				}
			}
		}
	}
}
</style>